/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_AddInputs */

const en_editor_ingredient_add = /** @type {(inputs: Editor_Ingredient_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredient`)
};

const de_editor_ingredient_add = /** @type {(inputs: Editor_Ingredient_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutat`)
};

/**
* | output |
* | --- |
* | "Ingredient" |
*
* @param {Editor_Ingredient_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_add = /** @type {((inputs?: Editor_Ingredient_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_add(inputs)
	return en_editor_ingredient_add(inputs)
});